import { render } from "./SearchItem.vue?vue&type=template&id=639acae7&scoped=true"
import script from "./SearchItem.vue?vue&type=script&lang=js"
export * from "./SearchItem.vue?vue&type=script&lang=js"

import "./SearchItem.vue?vue&type=style&index=0&id=639acae7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639acae7"]])

export default __exports__